import script from "./ButtonMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonMain.vue?vue&type=script&setup=true&lang=js"

import "./ButtonMain.vue?vue&type=style&index=0&id=edc4025a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edc4025a"]])

export default __exports__